import * as ajax from './ajax'
import { EventBus } from "../components/AudioPlayer";


// Special App check
export function isSPSite(ref) {
    let result = false;

    if (typeof ref.$cookie.get("siteCode") !== "undefined") {
        if (ref.$cookie.get("siteCode") !== null) {
            if (ref.$cookie.get("siteCode") !== "11") {
                result = true;
            }
        }
    }

    return result;
}

// login check
export function isLogin(ref) {
    let result = false;

    if (typeof ref.$cookie.get("accessToken") !== "undefined") {
        if (ref.$cookie.get("accessToken") !== null) {
            result = true;
        }
    }

    return result;
}

// get common code list
export function getCommonCodeList(ref, groupCode, listObject) {
    const param = {
        "group_code": groupCode,
        "use_yn": "Y"
    };

    ajax.Post(ref, "/api/common/code/search", param, function(ref, data) {
        for (const item of data) {
            listObject.push(item);
        }
    });
}

// play audio player
export function playAudioPlayer(courseNo) {
    EventBus.$emit('initcourseinfo', courseNo);
}

// set mini audio player
export function setAudioPlayer() {

    EventBus.$emit('setMiniPlayer');
}

// stop audio player
export function stopAudioPlayer() {

    EventBus.$emit('stopMiniPlayer');
}

// play audio player - schedule list
export function playScheduleAudioPlayer(courseNo, courseList) {
    // lte 재생여부 확인
    const app = EventBus;
    const lteStreaming = app.$cookie.get("lteStreaming");

    ajax.Get(app, "/api/contents/course/play/role/" + courseNo, function(ref, data) {
        if (data === "success")
            EventBus.$emit('initScheduleInfo', courseNo, courseList);
    });

}
